import './bottomBar.css';
import pfLogo from '../img/pfLogo.png';

const BottomBar = () => (
	<div id="bottom-bar">
		<div className="content-frame">
			<span>
				<img src={pfLogo} alt="Purpose First" title="Purpose First" className="stat-image"/>
				<span>Purpose First &copy; {new Date().getFullYear()}</span>
			</span>
			<span>
				<b>Powered By Purpose</b><br></br>
				Purpose First Foundation 501(c)(3)
			</span>
		</div>
	</div>
);

export default BottomBar;